import useScrollReveal from '../hooks/useScrollReveal';
import { TRAINERS_DATA } from '../data';
import './Trainers.css';

export default function Trainers() {
  const ref = useScrollReveal();

  return (
    <div ref={ref}>
      {/* HERO */}
      <div className="page-hero">
        <div className="trainers-hero-bg" />
        <div className="page-hero-overlay" />
        <div className="page-hero-content">
          <div className="sec-eyebrow fade-up">Expert Coaching</div>
          <h1 className="page-title-xl fade-up delay-1">THE<span className="acc">COACHES</span></h1>
        </div>
      </div>

      {/* STATS STRIP */}
      <div className="trainer-strip">
        <div className="ts-inner">
          {[
            ['50+', 'Certified Coaches'],
            ['200+', 'Certifications Held'],
            ['35K+', 'Sessions Delivered'],
            ['98%', 'Member Satisfaction'],
            ['15', 'Disciplines Covered'],
            ['6', 'International Athletes'],
          ].map(([n, l]) => (
            <div className="ts-stat" key={l}>
              <div className="ts-num">{n}</div>
              <div className="ts-label">{l}</div>
            </div>
          ))}
        </div>
      </div>

      {/* TRAINER GRID */}
      <section className="section" style={{ paddingTop: '5rem' }}>
        <div className="section-inner">
          <div className="text-center fade-up" style={{ marginBottom: '4rem' }}>
            <h2 className="sec-title">MEET THE <span className="acc">TEAM</span></h2>
            <div className="divider center" />
            <p className="sec-desc" style={{ textAlign: 'center', margin: '0 auto' }}>
              Our coaches hold an average of 4 certifications each. They don't just have credentials — they deliver results.
            </p>
          </div>
          <div className="trainer-grid">
            {TRAINERS_DATA.map((t, i) => (
              <div className={`tr-card fade-up delay-${(i % 3) + 1}`} key={t.name}>
                <img src={t.img} alt={t.name} className="tr-img" />
                <div className="tr-overlay" />
                <div className="tr-info">
                  <div className="cert-tags">
                    {t.certs.map((c) => (
                      <span className="tr-cert-tag" key={c}>{c}</span>
                    ))}
                  </div>
                  <div className="tr-name">{t.name}</div>
                  <div className="tr-spec">{t.spec}</div>
                  <div className="tr-bio">{t.bio}</div>
                  <div className="tr-socials">
                    {['𝕏', 'in', 'ig'].map((s) => (
                      <a key={s} className="tr-social">{s}</a>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* BOOKING SECTION */}
      <section className="section" style={{ background: 'var(--black2)' }}>
        <div className="section-inner">
          <div className="booking-grid">
            <div className="fade-left">
              <div className="sec-eyebrow">Work With Us</div>
              <h2 className="sec-title">BOOK A <span className="acc">SESSION</span></h2>
              <div className="divider" />
              <p className="sec-desc">
                Personal training sessions are available 7 days a week, 5am–10pm. Your first session is always a complimentary consultation — no charge, no pressure.
              </p>
              <div className="booking-features">
                {[
                  ['📅', 'Flexible Scheduling', 'Book online 24/7 or call our front desk'],
                  ['💬', 'Direct Communication', 'Message your coach directly via the app'],
                  ['🎯', 'Tailored Programmes', 'Every session aligned to your specific goals'],
                ].map(([ic, t, s]) => (
                  <div className="booking-feat" key={t}>
                    <span className="bf-icon">{ic}</span>
                    <div>
                      <div className="bf-title">{t}</div>
                      <div className="bf-sub">{s}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="fade-right">
              <img
                src="https://images.unsplash.com/photo-1576678927484-cc907957088c?w=800&q=80"
                alt="Training session"
                className="booking-img"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CERTIFICATIONS */}
      <section className="section" style={{ paddingTop: '6rem', paddingBottom: '6rem' }}>
        <div className="section-inner">
          <div className="text-center fade-up" style={{ marginBottom: '3rem' }}>
            <div className="sec-eyebrow" style={{ justifyContent: 'center' }}>Our Standards</div>
            <h2 className="sec-title">RECOGNISED <span className="acc">CERTIFICATIONS</span></h2>
            <div className="divider center" />
          </div>
          <div className="cert-grid fade-up delay-2">
            {['NSCA-CSCS', 'NASM-CPT', 'ACE-CPT', 'RYT-500', 'USAW', 'CrossFit L2', 'FMS', 'ACSM', 'CISSN', 'USA Boxing', 'DPT', 'SFMA'].map((cert) => (
              <div className="cert-pill" key={cert}>{cert}</div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
